import React from 'react';
import { EventCalendar } from 'components/Types/GeneralTypes';
import EventIcon from '../../Varios/EventIcons';
import { useIconColors } from 'Context/IconColorContext'; 

interface CustomEventProps {
    event: EventCalendar;
}

const CustomEvent: React.FC<CustomEventProps> = ({ event }) => {
    const iconColors = useIconColors();
    const iconStyle = { width: '2em', height: '2em' };
    let iconElement = <EventIcon tipo={event.tipo} style={iconStyle}/>;
    const iconInfo = iconColors?.find(icon => icon.id === event.tipo);
    const iconName = iconInfo ? iconInfo.descripcion : event.title; 
    if(event.tipoJornada==='C'){
        return (
            <div className="custom-event" style={{ 
                position: 'absolute',
                top: '8%', // Center vertically
                background: 'none', 
                border: 'none', 
                padding: 0, 
                cursor: 'pointer', 
                zIndex: 1 
            }}>
                {iconElement}
            </div>
        );
    }
    return (
        <div className="custom-event" style={{ backgroundColor: 'transparent', paddingTop: '1em', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <span className="d-none d-md-inline">{event.title}</span>
            <button title={iconName} style={{ width: '2em', height: '2em', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                {iconElement}
            </button>
        </div>
    );
}

export default CustomEvent;
